/* 문화포럼 일정 등록 페이지 */import Box          from '@mui/material/Box';
import React, {useEffect, useRef, useState}             from 'react';
import {constance}                                      from '../../common/constance/constance';
import Stack                                            from '@mui/material/Stack';
import {config}                                         from '../../common/config/config';
import Typography                                       from '@mui/material/Typography';
import TextField                                        from '@mui/material/TextField';
import axios                                            from 'axios';
import {styles}                                         from '../../common/style';
import {Button, MenuItem, MenuList, Paper} from '@mui/material';
import {common}                                         from '../../common/common';
import {User}                                           from '../../interface/user.interface';

interface State {
	title: string,
	time: number,
	creator: string,
	presenterName: string,
	userListOpen: boolean,
	userList: User[],
}


function CultureForumCalendarRegister() {
	const [state, setState] = useState<State>({
		title: '',
		time: 0,
		creator: '',
		presenterName: '',
		userListOpen: false,
		userList: [],
	});
	
	const titleRef: any = useRef();
	const timeRef: any = useRef();
	
	useEffect(() => {
		/* 사용자 리스트 가지고 오기 */
		axios.get(constance.api.getUserList).then((value) => {
			if (value.data.data) {
				console.log(value.data.data);
				for (let user of value.data.data) {
					user.name = user.name.trim();
					user.id = user.id.trim();
					user.departmentName = user.departmentName !== null ? user.departmentName.trim() : '';
					user.departmentCode = user.departmentCode.trim();
				}
				setState({
					...state,
					userList: value.data.data,
				});
			}
		}).catch(reason => {
			alert(reason);
		});
	}, []);
	
	const handleChange = (e: any, key: string) => {
		let value = e.target.value;
		setState({
			...state,
			[key]: value,
		});
	};
	
	function handleChangePresenter(e: any, user: User) {
		let value = e.currentTarget.value;
		setState({
			...state,
			userListOpen: false,
			creator: value,
			presenterName: `${user.departmentName} ${user.name}`,
		});
	}
	
	function handleOpenList() {
		setState({
			...state,
			presenterName: '',
			userListOpen: true,
		});
	}
	
	function handleSave() {
		if (state.creator == '') {
			common.alert('발표자 입력 오류', '발표자는 리스트에서 클릭하여 입력 가능합니다.', 'info');
			return;
		}
		const title = titleRef.current.value;
		const time = timeRef.current.value;
		axios.post(constance.api.createCultureForumCalendar, {
			title: title,
			time: time,
			creator: state.creator,
		}).then(value => {
			if (value.data.success) {
				common.alert('', '등록 성공', 'info');
			}
		}).catch(reason => {
			common.alert('', reason, 'error');
		});
	}
	
	return (
			<>
				<Stack sx={{width: 1, alignItems: 'center', justifyContent: 'center'}}>
					<Stack sx={{
						width: 1,
						mt: 3,
						maxWidth: config.maxWidth,
						alignItems: 'center',
						border: styles.border,
					}}>
						{/* 주제 */}
						<Box sx={{
							display: 'flex',
							borderBottom: styles.border,
							width: 1,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'주제'}</Typography>
							</Box>
							<Box
									sx={{
										flexGrow: 1,
										backgroundColor: styles.backgroundColor.contentBox,
										p: 1,
									}}>
								<TextField inputRef={titleRef}
								           placeholder="주제를 입력해주세요."
								           label="" variant="outlined"
								           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
								/>
							</Box>
						</Box>
						
						{/* 발표일 */}
						<Box sx={{
							display: 'flex',
							width: 1,
							borderBottom: styles.border,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'발표일'}</Typography>
							</Box>
							<Box sx={{
								flexGrow: 1,
								backgroundColor: styles.backgroundColor.contentBox,
								p: 1,
							}}>
								<TextField inputRef={timeRef}
								           label="문화포럼 시간"
								           type="datetime-local"
								           value={state.time}
								           onChange={(e) => handleChange(e, 'time')}
								           sx={{width: 250, backgroundColor: 'var(--scc-surface)', }}
								           InputLabelProps={{
									           shrink: true,
								           }}
								/>
							</Box>
						</Box>
						
						
						{/* 발표자 */}
						<Box sx={{
							display: 'flex',
							width: 1,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'발표자'}</Typography>
							</Box>
							<Box sx={{
								flexGrow: 1,
								backgroundColor: styles.backgroundColor.contentBox,
								p: 1,
								position: 'relative',
							}}>
								<TextField placeholder="발표자 이름을 입력해주세요."
								           value={state.presenterName}
								           onClick={handleOpenList}
								           onChange={(e) => handleChange(e, 'presenterName')}
								           label="" variant="outlined"
								           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
								/>
								<Paper sx={{
									width: 320, maxWidth: '100%',
									position: 'absolute',
									maxHeight: '400px',
									overflowY: 'auto',
									display: state.userListOpen ? 'flex' : 'none',
								}}>
									<MenuList>
										{
											state.userList.map((user, index) => {
												if (common.isEmpty(user.departmentName)) return;
												if (user.name == '이남주' && user.departmentName == '디자인팀') return;
												if (state.presenterName !== '') {
													if (user.name.indexOf(state.presenterName) == -1 && user.departmentName.indexOf(state.presenterName) == -1) {
														return;
													}
												}
												return (
														<MenuItem value={user.id}
														          key={index}
														          onClick={(e) => handleChangePresenter(e, user)}>
															<Typography>
																{`${user.departmentName} ${user.name}`}
															</Typography>
														</MenuItem>
												);
											})
										}
									</MenuList>
								</Paper>
							</Box>
						</Box>
					
					</Stack>
					
					<Box sx={{mt: 2}}>
						<Button onClick={handleSave}
						        variant={'contained'}>
							<Typography> {'등록'}</Typography>
						</Button>
					</Box>
				</Stack>
			</>
	);
};

export default CultureForumCalendarRegister;